import * as ShoppingCartItem from './ShoppingCartItem';
import * as PriceBreakdown from './PriceBreakdown';
import type { ShoppingCart as SC } from '../generated/checkout.graphql';
import { take } from '../util/takePayload';

export interface ShoppingCart {
  token: string;
  items: ShoppingCartItem.ShoppingCartItem[];
  dirty: boolean;
  priceBreakdown: PriceBreakdown.PriceBreakdown;
  controlQuantity: number;
  lockExpiresAt?: string;
  seatsioHoldToken?: string;
  total: number;
}

export const getNew = (): ShoppingCart => ({
  token: '',
  items: [],
  dirty: false,
  priceBreakdown: PriceBreakdown.getNew(),
  controlQuantity: 0,
  total: 0,
});

export const fromGql = (gqlItem: SC): ShoppingCart => ({
  ...(take(gqlItem, 'controlQuantity', 'lockExpiresAt', 'total', 'token', 'seatsioHoldToken') as ShoppingCart),
  items: gqlItem.items?.map(ShoppingCartItem.fromGql) || [],
  dirty: false,
  priceBreakdown: PriceBreakdown.fromGql(gqlItem.priceBreakdown),
});
